"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uses = exports.Imperfections = exports.Brand = exports.Quality = exports.Closure = exports.Material = exports.ZipperHardwareMaterial = exports.ZipperHardwareSU = exports.ZipperHardwareType = exports.ZipperType = exports.SellingUnit = void 0;
var SellingUnit;
(function (SellingUnit) {
    SellingUnit["Individual"] = "Individual";
    SellingUnit["Pack"] = "Pack";
    SellingUnit["Tape By The Meter"] = "Tape By The Meter";
    SellingUnit["Hardware"] = "Hardware";
})(SellingUnit = exports.SellingUnit || (exports.SellingUnit = {}));
var ZipperType;
(function (ZipperType) {
    ZipperType["Coil"] = "Coil";
    ZipperType["Metal"] = "Metal";
    ZipperType["Molded Plastic"] = "Molded Plastic";
    ZipperType["Invisible"] = "Invisible";
})(ZipperType = exports.ZipperType || (exports.ZipperType = {}));
var ZipperHardwareType;
(function (ZipperHardwareType) {
    ZipperHardwareType["Slider"] = "Slider";
    ZipperHardwareType["Stopper"] = "Stopper";
    ZipperHardwareType["Ender"] = "Ender";
    ZipperHardwareType["Pull"] = "Pull";
})(ZipperHardwareType = exports.ZipperHardwareType || (exports.ZipperHardwareType = {}));
// Zipper Hardware Selling Unit
var ZipperHardwareSU;
(function (ZipperHardwareSU) {
    ZipperHardwareSU["Individual"] = "Individual";
    ZipperHardwareSU["Pack"] = "Pack";
})(ZipperHardwareSU = exports.ZipperHardwareSU || (exports.ZipperHardwareSU = {}));
var ZipperHardwareMaterial;
(function (ZipperHardwareMaterial) {
    ZipperHardwareMaterial["Plastic"] = "Plastic";
    ZipperHardwareMaterial["Metal"] = "Metal";
    ZipperHardwareMaterial["Fabric"] = "Fabric";
})(ZipperHardwareMaterial = exports.ZipperHardwareMaterial || (exports.ZipperHardwareMaterial = {}));
var Material;
(function (Material) {
    Material["Plastic"] = "Plastic";
    Material["Metal"] = "Metal";
})(Material = exports.Material || (exports.Material = {}));
var Closure;
(function (Closure) {
    Closure["Separating"] = "Separating";
    Closure["Two-Way Separating"] = "Two-Way Separating";
    Closure["Closed End"] = "Closed End";
})(Closure = exports.Closure || (exports.Closure = {}));
var Quality;
(function (Quality) {
    Quality["Vintage"] = "Vintage";
    Quality["Designer"] = "Designer";
    Quality["Heavy Duty"] = "Heavy Duty";
})(Quality = exports.Quality || (exports.Quality = {}));
var Brand;
(function (Brand) {
    Brand["YKK"] = "YKK";
})(Brand = exports.Brand || (exports.Brand = {}));
var Imperfections;
(function (Imperfections) {
    Imperfections["Discolouration"] = "Discolouration";
    Imperfections["Scented"] = "Scented";
    Imperfections["Sticky"] = "Sticky";
    Imperfections["Sticky Slider"] = "Sticky Slider";
    Imperfections["Frayed Tape"] = "Frayed Tape";
    Imperfections["Stain"] = "Stain";
})(Imperfections = exports.Imperfections || (exports.Imperfections = {}));
var Uses;
(function (Uses) {
    Uses["Home Decor"] = "Home Decor";
    Uses["Accessories"] = "Accessories";
    Uses["Apparel"] = "Apparel";
})(Uses = exports.Uses || (exports.Uses = {}));
//# sourceMappingURL=zipperAttributes.js.map